import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { LucideAngularModule, Sun, Moon, Globe, Check, Menu, X, ChevronRight, ChevronLeft, ChevronsRight, ChevronDown, Home, ClipboardList, BarChart3, Settings, Bell, DollarSign, CreditCard, TrendingUp, Users, ArrowUpRight, Receipt, AlertTriangle, Wallet, Headphones, Code, MessageCircleQuestionMark, PieChart, Activity, User, Shield, Search, Book, Aperture, Cpu, Columns, Wrench, Circle, FileText, MoreVertical, Pencil, Copy, Trash, Trash2, CheckCircle, List, RefreshCcw, PlusCircle, Sparkles, Wand2, Ban, BellOff, Loader2, RefreshCw, AlertCircle, Edit, SquarePen } from 'lucide-angular';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';

import { routes } from './app.routes';
import { createTranslateLoader } from './core/config/translate-loader.config';
import { environment } from '../environments/environment';

// Socket.IO configuration
const socketConfig: SocketIoConfig = {
  url: environment.socketUrl,
  options: { transports: ['websocket'] }
};

// HTTP Interceptors
import {
  authInterceptor,
  errorInterceptor,
  loadingInterceptor,
  retryInterceptor,
} from './core/interceptors';

// Global Error Handler
import { GlobalErrorHandlerService } from './core/services/global-error-handler.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    
    // HTTP Client with interceptors (order matters!)
    provideHttpClient(
      withInterceptors([
        loadingInterceptor,  // Track loading state
        authInterceptor,     // Add auth token
        retryInterceptor,    // Retry failed requests
        errorInterceptor,    // Handle errors globally
      ])
    ),
    
    // Global error handler
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    
    // Translation
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    
    // Socket.IO
    importProvidersFrom(
      SocketIoModule.forRoot(socketConfig)
    ),
    
    // Lucide icons
    importProvidersFrom(
      LucideAngularModule.pick({
        Sun,
        Moon,
        Edit,
        Globe,
        Check,
        AlertCircle,
        Menu,
        X,
        ChevronRight, 
        ChevronLeft,
        ChevronsRight,
        ChevronDown,
        Home,
        ClipboardList,
        BarChart3,
        Settings,
        Loader2,
        Bell,
        RefreshCw,
        BellOff,
        Pencil,
        DollarSign,
        CreditCard,
        TrendingUp,
        PlusCircle,
        Copy,
        RefreshCcw,
        Trash2,
        Users,
        ArrowUpRight,
        Receipt,
        MessageCircleQuestionMark,
        AlertTriangle,
        MoreVertical,
        CheckCircle,
        Sparkles,
        List,
        Wand2,
        Ban,
        Wallet,
        FileText,
        Headphones,
        Search,
        Code,
        PieChart,
        Activity,
        User,
        Circle,
        Shield,
        Book,
        Aperture,
        Cpu,
        Columns,
        Wrench
      })
    )
  ]
};
